import { gql } from '@graphql/__generated__';
import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const REVIEW_REPLY_ANCHORS = {
  reply: 'review-reply',
  manage: 'review-reply-manage',
} as const;

const GET_TOUR_REVIEW = gql(/* GraphQL */ `
  query GetReviewReplyTourReview($userId: uuid!) {
    unanswered: reviews(
      where: {
        user_id: { _eq: $userId }
        completed: { _eq: true }
        owner_answer: { _is_null: true }
      }
      order_by: [{ completed_at: desc_nulls_last }]
      limit: 1
    ) {
      id
    }
    any: reviews(
      where: { user_id: { _eq: $userId }, completed: { _eq: true } }
      order_by: [{ completed_at: desc_nulls_last }]
      limit: 1
    ) {
      id
    }
    visible: reviews(
      where: { completed: { _eq: true }, owner_answer: { _is_null: true } }
      order_by: [{ completed_at: desc_nulls_last }]
      limit: 1
    ) {
      id
    }
  }
`);

// The reply card of a review drawer (`ReviewAnswerCard.tsx`). Played from
// "Show me" on `content/releases/reviews-replies`. A review shows either the
// reply button or the edit/delete buttons, so the tour starts on either.
export const reviewReplyTour: TourModule = {
  steps: t => [
    {
      anchor: REVIEW_REPLY_ANCHORS.reply,
      title: t('Reply to this review'),
      body: t(
        'Your reply appears under the review on your agent and agency profiles.',
      ),
      placement: 'top-start',
    },
    {
      anchor: REVIEW_REPLY_ANCHORS.manage,
      title: t('Change your reply'),
      body: t('Edit or delete your reply at any time.'),
      placement: 'left',
    },
  ],
  startOnAnyStep: true,
  // The user's latest review without a reply, else their latest review, else
  // the latest unanswered review they can see (admins reply for their agents).
  resolvePath: async ({ client, userId }) => {
    const { data } = await client.query({
      query: GET_TOUR_REVIEW,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    const reviewId =
      data?.unanswered[0]?.id ?? data?.any[0]?.id ?? data?.visible[0]?.id;
    return reviewId == null ? null : `/visibility/reviews/${reviewId}`;
  },
};
